var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWsaVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 1240,
    viewBox: "0 0 311 1240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.25H311L250.567 1298.75H0V-0.25Z",
    fill: "#1D6DAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsaVector2);
export default __webpack_public_path__ + "static/media/wsa_vector2.cc049f6f797aa9b9dba1c417da5e1c66.svg";
export { ForwardRef as ReactComponent };